/**
 * Converts data from an API response into a format suitable for a bookmark drawer.
 *
 * @param {API} data
 * @returns {Array} An array of custom fields for the bookmark drawer.
 */
const getCustomFieldBookmarks = data => {
	if (!data?.entry) return [];

	return data?.entry.map(({ resource, fullUrl }) => {
		const { name, type, internalCustomFieldID, internalOrganizationID, isActive } = resource;

		return {
			id: fullUrl,
			fullUrl: fullUrl,
			code: name,
			display: name,
			section: type,
			fieldId: internalCustomFieldID,
			internalOrganizationID,
			isActive,
		};
	});
};

export default getCustomFieldBookmarks;
